import FirebaseAdapter from "@wc/adapters/firebase";
import { PermissionsEnum, userHasPermissionInOrg } from "@wc/domain/authz";

/**
 * @typedef {import('@wc/domain/users/models').AuthnUser} AuthnUser
 */

/**
 * Revokes (soft deletes) an invite
 * @param {string} token The invite token
 * @param {AuthnUser} user The user revoking
 * @returns {Promise<void>}
 */
export async function revokeInvite(token, user) {
  const invite = await FirebaseAdapter().invites.getInvite(token);

  if (!invite) {
    throw new Error("Invite not found");
  }

  const hasPermission = await userHasPermissionInOrg(
    user,
    invite.organizationId,
    PermissionsEnum.MANAGE_ORGANIZATION_MEMBERS,
  );

  if (!hasPermission) {
    throw new Error("You do not have permission to revoke invites");
  }

  await FirebaseAdapter().invites.deleteInvite(token, user.id);
}
